<template>
  <div class="app-main__inner">
    <TituloComponent icono-titulo="fas fa-pencil-alt" texto-titulo="Editar Seccion"></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <form @submit.prevent="guardarSeccion()">
          <float-label label="Código:" clase>
            <input
              v-model="seccion.codigo"
              id="codigo"
              placeholder="Ingresar un código..."
              type="text"
              class="form-control"
              :class="
                enviado && !$v.seccion.codigo.required
                  ? 'is-invalid'
                  : ''
              "
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.seccion.codigo.required"
              >
                Debe ingresar un código
              </div>
            </template>
          </float-label>
          <float-label label="Descripción:" clase>
            <input
              v-model="seccion.descripcion"
              id="descripcion"
              placeholder="Ingresar una descripción..."
              type="text"
              class="form-control"
              :class="(enviado && !$v.seccion.descripcion.required) ? 'is-invalid' : ''"
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.seccion.descripcion.required"
              >Debe ingresar una descripción</div>
            </template>
          </float-label>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponente";import FloatLabel from "@/components/layouts/FloatLabel";
import { required } from 'vuelidate/lib/validators';
import axios from "axios";
import Swal from "sweetalert2";
import Seccion from "@/models/seccion";
export default {
  name: "EditarSeccion",
  components: {
    TituloComponent,
    FloatLabel,
  },
  data() {
    return {
      seccion: new Seccion(null, "", ""),
      loading: false,
      enviado:false
    };
  },  
  validations:{
    seccion:{
      codigo:{required},
      descripcion:{required},
    }
  },
  mounted() {
    this.seccion.id = this.$route.params.id;
    this.getSeccion();
  },
  methods: {
    getSeccion() {
      this.loading = true;
      axios
        .get("seccion/" + this.seccion.id)
        .then(res => {
          console.log(res.data);
          if (res.data.success) {
            this.seccion = res.data.seccion;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado secciones.`
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    guardarSeccion() {
      this.enviado = true
      this.loading = true;
      this.$v.$touch();
      if(this.$v.$invalid){
        this.loading = false;
        return false;
      }
      axios
        .put("/seccion/" + this.seccion.id, this.seccion)
        .then(res => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.seccion.descripcion} se editó con éxito.`
            });
            this.$router.push({ name: "ListarSecciones" });
          }
        })
        .catch(error => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`
          });
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>